import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyABMsYC8MxAd9GH9rcvu5R5twmiQUW4UA0",
  authDomain: "clone-adcd6.firebaseapp.com",
  projectId: "clone-adcd6",
  storageBucket: "clone-adcd6.appspot.com",
  messagingSenderId: "319842599296",
  appId: "1:319842599296:web:3acd6718a5efd3b0b04165",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
